<div class="productBox">
  <a [routerLink]="product.safeProductUrl" title="{{product.title}}">
    <div class="productImage">
      <div [style.background-image]="product.safeBackgroundImageUrl" class="backgroundImage"></div>
      <div class="productMasking">
      </div>
    </div>
  </a>
  <div class="productCaption">
    <div class="row">
      <div class="col">
        <a [routerLink]="product.safeProductUrl" title="{{product.title}}">
          <h5>{{product.title}}</h5>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (product.metadata.saleActive) {
          <div class="price">
            <span class="standard-price">{{product.formattedStandardPrice}}</span>
            <span class="sale-price"> {{product.formattedPrice}}</span>
          </div>
        }
        @if (!product.metadata.saleActive) {
          <div class="price">
            <div>{{product.formattedPrice}}</div>
          </div>
        }
      </div>
      <div class="favourites">
        @if (!favouritesService.favouritesMap[product.code]) {
          <a id="add-to-favourites-{{index}}"
            (click)="addToFavourites()">
            <i class="far fa-heart"></i>
          </a>
        }
        @if (favouritesService.favouritesMap[product.code]) {
          <a id="remove-from-favourites-{{index}}"
            (click)="removeFromFavourites()">
            <i class="fas fa-heart"></i>
          </a>
        }
      </div>
    </div>
  </div>
</div>